var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 700,
    viewBox: "0 0 1152 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47:2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 632,
    cy: 422,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 234,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 627,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547,
    cy: 221,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 669,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1094,
    cy: 429,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 290,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 827,
    cy: 102,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 495,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 89,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 537,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 792,
    cy: 297,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 323,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840,
    cy: 135,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 528,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 122,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 570,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 805,
    cy: 330,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 293,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 987,
    cy: 105,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1003,
    cy: 498,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405,
    cy: 92,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 540,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 300,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501,
    cy: 434,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 998,
    cy: 246,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1014,
    cy: 639,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 233,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475,
    cy: 681,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963,
    cy: 441,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 374,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873,
    cy: 186,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 579,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 173,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 621,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 838,
    cy: 381,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 309,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1061,
    cy: 121,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1077,
    cy: 514,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 108,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 556,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026,
    cy: 316,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364,
    cy: 289,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861,
    cy: 101,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877,
    cy: 494,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 88,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 536,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 296,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 436,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 248,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 641,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 235,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 683,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767,
    cy: 443,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 224,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 36,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1065,
    cy: 429,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467,
    cy: 23,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 526,
    cy: 471,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1014,
    cy: 231,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 417,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 229,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 705,
    cy: 622,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 216,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 664,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 654,
    cy: 424,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 430,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685,
    cy: 242,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 701,
    cy: 635,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 229,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 677,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 437,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 378,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941,
    cy: 190,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 957,
    cy: 583,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359,
    cy: 177,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 625,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 385,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 293,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 105,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645,
    cy: 498,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 92,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 540,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 300,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547,
    cy: 379,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1044,
    cy: 191,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 584,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462,
    cy: 178,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521,
    cy: 626,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 386,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 247,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 742,
    cy: 59,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 758,
    cy: 452,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 46,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 494,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707,
    cy: 254,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 380,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947,
    cy: 192,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963,
    cy: 585,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 179,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 627,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 912,
    cy: 387,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 248,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645,
    cy: 60,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 661,
    cy: 453,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 47,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 495,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 255,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 325,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 735,
    cy: 137,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751,
    cy: 530,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 124,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 572,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 332,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 261,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 966,
    cy: 73,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 982,
    cy: 466,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 60,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443,
    cy: 508,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931,
    cy: 268,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 654,
    cy: 397,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1151,
    cy: 209,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 196,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 644,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1116,
    cy: 404,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 315,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1043,
    cy: 127,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1059,
    cy: 520,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 461,
    cy: 114,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 562,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1008,
    cy: 322,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544,
    cy: 346,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1041,
    cy: 158,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1057,
    cy: 551,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459,
    cy: 145,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 593,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1006,
    cy: 353,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 326,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1072,
    cy: 138,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1088,
    cy: 531,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 125,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 573,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1037,
    cy: 333,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 342,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1032,
    cy: 154,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 547,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 141,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 589,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 997,
    cy: 349,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523,
    cy: 257,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 69,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 462,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 56,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497,
    cy: 504,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 985,
    cy: 264,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 365,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 177,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 570,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 164,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 612,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 372,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 269,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 965,
    cy: 81,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 981,
    cy: 474,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 68,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 516,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 276,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 416,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 228,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 621,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 215,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 663,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 871,
    cy: 423,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 238,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 907,
    cy: 50,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 923,
    cy: 443,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 37,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 485,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872,
    cy: 245,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 384,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 983,
    cy: 196,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 999,
    cy: 589,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401,
    cy: 183,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 631,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 391,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 261,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 788,
    cy: 73,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 804,
    cy: 466,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 60,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 508,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753,
    cy: 268,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 375,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 736,
    cy: 187,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 752,
    cy: 580,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 174,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 622,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 701,
    cy: 382,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 432,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 701,
    cy: 244,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717,
    cy: 637,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 231,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 679,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 439,
    r: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47:2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 700,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars3);
export default __webpack_public_path__ + "static/media/stars3.808e270bdcf47763c4b75961942ec1a8.svg";
export { ForwardRef as ReactComponent };